import { defineStore } from 'pinia'
import { get, post, patch, del, ApiError } from '../lib/api'

export const useSession = defineStore('session', {
  state: () => ({ user: null, loaded: false }),
  getters: { signedIn: (s) => !!s.user },
  actions: {
    async load() {
      try {
        const data = await get('/api/me')
        this.user = data.user
      } catch (e) {
        if (!(e instanceof ApiError && e.status === 401)) throw e
        this.user = null
      } finally {
        this.loaded = true
      }
    },
    async login(email, password) {
      const data = await post('/api/session', { user: { email, password } })
      this.user = data.user
    },
    async register(email, password) {
      const data = await post('/api/registration', { user: { email, password, password_confirmation: password } })
      this.user = data.user
    },
    async logout() {
      await del('/api/session')
      this.user = null
      await this.load()
    },
    async update(attrs) {
      const data = await patch('/api/me', { user: attrs })
      this.user = data.user
    },
  },
})
